<template>
  <div :style="`transform: translate(${offsetX}px, ${offsetY}px) !important`"
       :class="`number-badge ${badgeColor} font-weight-black`"><p style="line-height: 1" class="pa-0 ma-0">{{ count }}</p>
  </div>
</template>

<script>
export default {
  name: 'NumberBadge',
  props: {
    /** theme color such as 'primary' or the like */
    badgeColor: String,
    count: Number,
    offsetX: {type: Number, default: -1},
    offsetY: {type: Number, default: -6},
  },
};
</script>

<style scoped>
.number-badge {
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  font-size: 11px;
  color: white;
  text-align: center;
  display: flex;

  align-items: center;
  justify-content: center;
  padding: 2px;
}
</style>